/**
 * Format an accounting amount for display.
 *
 * Accounting amounts (order lines, documents) are stored in øre in the DB for
 * precision; auction/bid amounts are stored in whole kroner. Always pass øre
 * values here — the helper divides by 100 so callers never repeat that logic.
 */
export function formatMoney(amount: number | null | undefined, currency = "NOK"): string {
  if (amount == null) return "—";
  const majorUnits = amount / 100;
  return `${majorUnits.toLocaleString("nb-NO", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} ${currency}`;
}

export function formatAuctionEnd(endsAt: string | null): string {
  if (!endsAt) return "Ukjent";
  const end = new Date(endsAt);
  const now = new Date();
  
  // Strip time for day comparison
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endDay = new Date(end.getFullYear(), end.getMonth(), end.getDate());
  
  const diffDays = Math.round((endDay.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  const timeStr = end.toLocaleTimeString("nb-NO", { hour: "2-digit", minute: "2-digit" });

  if (diffDays === 0) return `I dag kl. ${timeStr}`;
  if (diffDays === 1) return `I morgen kl. ${timeStr}`;
  if (diffDays < 0) return `Avsluttet`;
  
  return `${end.toLocaleDateString("nb-NO", { day: "numeric", month: "short" })} kl. ${timeStr}`;
}
